import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconArrowUpOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m12.75 2.871 8.266 8.266a.75.75 0 0 0 1.06-1.06L12 0 1.924 10.076a.75.75 0 0 0 1.06 1.06l8.266-8.265V23.25a.75.75 0 0 0 1.5 0z" /></svg>
);
